export function getSymbolNameParts(fullName) {
  const [nameOrSprite, nameOrUndefined] = fullName.split("/");
  return {
    symbol: nameOrUndefined || nameOrSprite,
    sprite: nameOrUndefined ? nameOrSprite : "default"
  };
}
